import { Box, SimpleGrid } from '@chakra-ui/react'
import { useRender } from 'redity'
import Keys from '../../keys'
import { nextColors, storagePage } from '../../storage'
import BoxItem from './BoxItem'

export default function ListItems() {
    useRender(Keys.LIST_ITEM)

    let _i = 0

    function getColor() {
        if (_i > 5) {
            _i = 0
        }

        return nextColors[_i++]
    }

    return (
        <Box
            w="full"
            p={{
                base: '4',
                lg: '5'
            }}
            bg="white"
            maxH={{
                base: 'calc(100vh - 260px)',
                lg: 'calc(100vh - 60px)'
            }}
            overflow="auto"
        >
            {storagePage.items.length > 0 && (
                <SimpleGrid
                    spacing={3}
                    minChildWidth={{
                        sm: '150px',
                        xl: '160px'
                    }}
                >
                    {storagePage.items.map((item, i) => (
                        <BoxItem
                            index={i}
                            item={item}
                            bg={getColor()}
                            key={i}
                        />
                    ))}
                </SimpleGrid>
            )}
            {storagePage.items.length === 0 && (
                <Box textAlign="center" color="gray-3">
                    No existen resultados
                </Box>
            )}
        </Box>
    )
}
